import type { ReferenceProvider } from './types'

export * from './types'
export * from './validation'

let instance: Promise<ReferenceProvider> | null = null

/**
 * The live reference-data provider.
 *
 * Loaded through a dynamic import for the same reason as the auth provider
 * (CODE-RULES 3.3): a build ships only the provider it runs on. The Supabase
 * provider slots in here behind a VITE_REFERENCE_PROVIDER switch once the
 * tables exist; no UI file changes when it does.
 */
export function getReferenceProvider(): Promise<ReferenceProvider> {
  if (instance) return instance
  instance = import('./local-provider').then((m) => new m.LocalReferenceProvider())
  return instance
}
